import React from 'react';
import { Check } from 'lucide-react';
interface ProjectTypeSelectorProps {
  selectedTypes: string[];
  onToggle: (type: string) => void;
}
export const ProjectTypeSelector: React.FC<ProjectTypeSelectorProps> = ({
  selectedTypes,
  onToggle
}) => {
  const categories = [{
    name: "Veranda's & Overkappingen",
    types: [{
      id: 'veranda',
      name: 'Veranda',
      description: 'Overkapping tegen de woning',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eiKEog1ipMyXoPUtXBqhnu/IMG_20190913_144239-scaled-2.jpg'
    }, {
      id: 'overkapping',
      name: 'Overkapping',
      description: 'Vrijstaande constructie',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3Z4yk6TwjVAbDA4paNizR9/IMG_5124-1024x576.jpg'
    }, {
      id: 'tuinkamer',
      name: 'Tuinkamer',
      description: 'Volledig afgesloten ruimte',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vffEbyujZ16QzAiNyeYAva/MB_Veranda_Deventer_social_content_092-scaled-545x409x0x0x545x409x1733397477.webp'
    }]
  }, {
    name: 'Wanden & Deuren',
    types: [{
      id: 'schuifwanden',
      name: 'Schuifwanden',
      description: 'Glazen of aluminium wanden',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qdZM8nivB1Yyk7qr3hip3K/Glazen-schuifwand-3.webp'
    }]
  }, {
    name: 'Zonwering',
    types: [{
      id: 'zonwering',
      name: 'Zonwering',
      description: 'Bescherming tegen zonlicht',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pYevtk8Ydq1HQfS8zp33Ga/Photo-2.png'
    }]
  }, {
    name: 'Overige diensten',
    types: [{
      id: 'carport',
      name: 'Carport',
      description: 'Overkapping voor auto',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/shjtt1Bxf2C29Ro4hXuF77/Carport.jpg'
    }, {
      id: 'tuinbestrating',
      name: 'Tuinbestrating',
      description: 'Tegels, klinkers of natuursteen',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sQdRcEfDg3cmH2XT3UqKCc/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.19_fa7eea2b.jpg'
    }, {
      id: 'schutting',
      name: 'Schutting',
      description: 'Hout of beton',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xxPuNDsXGaUcEKqqdjT9ZN/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.17_d6a24884.jpg'
    }, {
      id: 'zandcementvloer',
      name: 'Zandcementvloer',
      description: 'Egale ondergrond',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3QYBorzzwNoLHmVy1gqjhE/20150604_110616.jpg'
    }]
  }];
  return <div className="space-y-8 mb-8" data-id="element-776">
      {categories.map(category => <div key={category.name} className="space-y-4" data-id="element-777">
          <h3 className="text-lg font-semibold text-white/90 border-b border-white/20 pb-2" data-id="element-778">
            {category.name}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-779">
            {category.types.map(type => <div key={type.id} onClick={() => onToggle(type.id)} className={`relative rounded-lg cursor-pointer transition-all duration-300 overflow-hidden ${selectedTypes.includes(type.id) ? 'ring-2 ring-[#CDA735] shadow-lg transform scale-[1.02]' : 'hover:ring-1 hover:ring-white/30'}`} data-id="element-780">
                {/* Image with overlay */}
                <div className="relative h-44 overflow-hidden" data-id="element-781">
                  <img src={type.image} alt={type.name} className="w-full h-full object-cover transition-transform duration-500 ease-in-out" style={{
              transform: selectedTypes.includes(type.id) ? 'scale(1.05)' : 'scale(1)'
            }} data-id="element-782" />
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/80 to-black/20 transition-opacity duration-300 ${selectedTypes.includes(type.id) ? 'opacity-80' : 'opacity-70'}`} data-id="element-783"></div>
                </div>
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-784">
                  <div className="flex justify-between items-end" data-id="element-785">
                    <div data-id="element-786">
                      <h3 className="font-medium text-lg" data-id="element-787">{type.name}</h3>
                      <p className="text-sm text-white/80" data-id="element-788">
                        {type.description}
                      </p>
                    </div>
                    {selectedTypes.includes(type.id) && <div className="w-6 h-6 rounded-full bg-[#CDA735] flex items-center justify-center" data-id="element-789">
                        <Check className="h-4 w-4 text-white" data-id="element-790" />
                      </div>}
                  </div>
                </div>
                {/* Selected overlay */}
                {selectedTypes.includes(type.id) && <div className="absolute top-3 right-3" data-id="element-791">
                    <div className="px-2 py-1 bg-[#CDA735] rounded-md text-xs font-medium text-white" data-id="element-792">
                      Geselecteerd
                    </div>
                  </div>}
              </div>)}
          </div>
        </div>)}
    </div>;
};